const config = {
    VERSION: process.env.VERSION,
};

export default config;

export const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL;

export const CLIENT_ID_FRIST = process.env.REACT_APP_CLIENT_ID_FIRST;

export const CLIENT_ID_SECOND = process.env.REACT_APP_CLIENT_ID_SECOND;